import Vue from 'vue';

import VaimoIcon from '~/diptyqueTheme/components/atoms/VaimoIcon.vue';
Vue.component('VaimoIcon', VaimoIcon);
